import RestResource from '../rest.service';

export default class PreEmergenceService extends RestResource {
  map(payload) {
    return {
      phosphate_fertilization: payload.phosphateFertilization,
      nitrogen_fertilization: payload.nitrogenFertilization,
      seed_date: payload.seedDate,
      weed_control: payload.weedControl,
      pest_control: payload.pestControl,
      plot_id: payload.plotId,
      comment: payload.comment,
      production_destination_id: payload.productionDestination,
      seeds_per_meter: payload.seedsPerMeter,
    };
  }

  mapAttach(payload) {
    return {
      pictures: payload,
    };
  }

  constructor() {
    super('pre-emergences');
  }
}
